<div
  fxLayout="row"
  style="margin-top: 10px"
  *ngIf="user_obs | async as user_data"
>
  <div fxFlex="30" style="padding: 5px">
    <mat-card>
      <mat-card-content>
        <div class="example-button-row" style="display: grid">
          <button mat-flat-button color="primary">
            <mat-icon>edit</mat-icon> Editar la cuenta y perfil
          </button>
        </div>

        <mat-list>
          <mat-list-item
            style="display: inline"
            title="Numero total de observaciones"
          >
            <mat-icon mat-list-icon>search</mat-icon>
            <div mat-line>Observaciones</div>
            <div class="label" align="end">
              {{ user_data.data.stats.observation_count }}
            </div>
          </mat-list-item>

          <mat-divider></mat-divider>
          <mat-list-item
            style="display: inline"
            title="Numero de observaciones publicas"
          >
            <mat-icon mat-list-icon>search</mat-icon>
            <div mat-line>Obs. Publicas</div>
            <div class="label" align="end">
              {{ user_data.data.stats.public_count }}
            </div>
          </mat-list-item>

          <mat-divider></mat-divider>
          <mat-list-item title="Numero de variedades utilizadas">
            <mat-icon mat-list-icon>eco</mat-icon>
            <div mat-line>Variedades</div>
            <div class="label" align="end">
              {{ user_data.data.stats.variety_count }}
            </div>
          </mat-list-item>

          <mat-divider></mat-divider>
          <mat-list-item title="Numero de seguidores del usuario">
            <mat-icon mat-list-icon>person</mat-icon>
            <div mat-line>Seguidores</div>
            <div class="label" align="end">0</div>
          </mat-list-item>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxFlex="70" style="padding: 5px">
    <mat-card>
      <mat-card-title
        >{{ user_data.data.first_name }}
        {{ user_data.data.last_name }}</mat-card-title
      >
      <mat-card-subtitle>
        <mat-icon style="font-size: 15px">calendar_month</mat-icon>Fecha de
        inicio de cuenta, el 13 nov. 2022 |
        <mat-icon style="font-size: 15px">schedule</mat-icon>Ultima actividad,
        el 14 nov. 2022
      </mat-card-subtitle>

      <mat-card-content>
        <p>
          ¿Estudias variedades de papa? ¿Eres el mejor experto del mundo en
          variedades de papas? ¿Solo te gusta mirar las variedades bonitas? Al
          llenar tu perfil agregas un poco de personalidad y estableces
          credibilidad cuando ayudes a otras personas con las identificaciones.
        </p>
      </mat-card-content>

      <br />
      <mat-card-title>Siguiendo a 0 personas</mat-card-title>
      <mat-card-content>
        <p>
          No sigues a nadies. Seguir a otros observadores de WIKIPAPA te
          permitira llevar un control de sus observaciones mas recientes.
          Averigua lo que la gente esta observando y has nuevos conocidos.
        </p>
      </mat-card-content>
    </mat-card>
  </div>
</div>
